<script setup lang="ts">
    const { bannerVariant, invoicesCount, totalDue, unblockedUntil } = useUnpaidStatus();
    const { countLabel, countLabelCapitalized } = useUnpaidCountLabel(invoicesCount);
    const { $price } = useNuxtApp();
    const { track, trackBannerViewed, setInvoicesSource } = useUnpaidTracking();

    watch(
        () => bannerVariant.value?.level,
        (level) => level && trackBannerViewed(),
        { immediate: true }
    );

    const onCtaClick = () => {
        track('unpaid_banner_cta_clicked', { unpaid_level: bannerVariant.value?.level });
        setInvoicesSource('banner');
    };

    // `date` only feeds the level 4 temporary-unblock copy ("jusqu'au 14/10/2026").
    const params = computed(() => ({
        count: invoicesCount.value,
        countLabel: countLabel.value,
        countLabelCap: countLabelCapitalized.value,
        total: $price(totalDue.value),
        date: unblockedUntil.value?.format('DD/MM/YYYY') ?? '',
    }));
</script>

<template>
    <CollapsibleBanner
        v-if="bannerVariant"
        :class="[bannerVariant.classes, bannerVariant.dark ? 'text-branding-rich-black' : 'text-white']"
    >
        <template #title>
            <p class="font-bold text-base leading-tight">
                <span class="max-md:hidden">{{ $t(bannerVariant.titleKey, params) }}</span>
                <span class="md:hidden">{{ $t(bannerVariant.titleSmKey, params) }}</span>
            </p>
        </template>
        <template #body>
            <p class="leading-tight text-13 max-md:text-sm max-md:leading-snug">
                {{ $t(bannerVariant.subtitleKey, params) }}
            </p>
        </template>
        <template #action>
            <NuxtLink
                to="/settings/invoices"
                class="flex items-center gap-1.5 h-6.5 px-2.5 bg-white border border-gray-300 rounded text-gray-700 text-11 font-medium shadow-sm hover:bg-gray-50 transition-colors focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none max-md:h-9 max-md:px-3 max-md:text-sm max-md:justify-center"
                @click="onCtaClick"
            >
                <i
                    class="fa-regular fa-building-columns text-xs"
                    aria-hidden="true"
                ></i>
                <span>{{ $t(bannerVariant.ctaKey) }}</span>
            </NuxtLink>
        </template>
    </CollapsibleBanner>
</template>
